<template>
  <div class="JanitorManagement">
    <el-form :inline="true"
             :model="searchForm"
             @keyup.enter.native="getDataList('search')">
      <el-form-item label="管理员名称">
        <el-input v-model="searchForm.janitorName"
                  placeholder="管理员名称"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button icon="el-icon-search"
                   size="small"
                   type="primary"
                   @click="getDataList('search')">搜索
        </el-button>
        <el-button icon="el-icon-delete"
                   size="small"
                   plain
                   type="primary"
                   @click="reset()">清空
        </el-button>
      </el-form-item>
      <el-row v-if="roleId===1">
        <el-col :span="12">
          <el-button icon="el-icon-plus"
                     size="small"
                     type="primary"
                     @click="openAddJanitorDialog">添加管理员
          </el-button>
        </el-col>
      </el-row>
    </el-form>

    <el-tabs v-model="activeName"
             @tab-click="handleClick"
             style="margin-top: 20px;">

      <el-tab-pane :label="item.apartmentName"
                   :name="String(item.apartmentId)"
                   v-for="(item, index) in apartmentList"
                   :key="index">

        <el-table class="dataTable"
                  v-loading="dataListLoading"
                  :data="dataList"
                  :header-cell-style="{'text-align':'center'}"
                  :cell-style="{'text-align':'center'}"
                  border>
          <el-table-column label="公寓名称"
                           prop="apartmentName">
          </el-table-column>

          <el-table-column label="管理员名称"
                           prop="userName">
          </el-table-column>


          <el-table-column label="管理员手机号"
                           prop="userPhone">
          </el-table-column>

          <el-table-column label="添加时间"
                           prop="createTime">
          </el-table-column>

          <el-table-column label="操作"
                           width="400">
            <template slot-scope="scope">

<!--              <el-button size="mini"-->
<!--                         type="primary"-->
<!--                         @click="openDetailDialog(scope.row)">查看-->
<!--              </el-button>-->
              <el-button size="mini"
                         type="primary"
                         v-if="roleId===1 || scope.row.userId===userInfo.userId"
                         @click="openDetailDialog(scope.row)">编辑
              </el-button>
              <el-button size="mini"
                         type="danger"
                         @click="handleDelete(scope.row)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination :current-page="pageIndex"
                       :page-size="pageSize"
                       :page-sizes="[10, 20, 50, 100]"
                       :total="totalPage"
                       background
                       layout="total, sizes, prev, pager, next, jumper"
                       @size-change="sizeChangeHandle"
                       @current-change="currentChangeHandle">
        </el-pagination>
      </el-tab-pane>
    </el-tabs>


    <!-- 新增管理员 -->
    <el-dialog title="添加管理员"
               :visible.sync="addJanitorDialog"
               v-loading="dataListLoading"
               width="40%"
               :before-close="cancelAddJanitorDialog">
      <el-form class="addJanitorForm"
               ref="addJanitorForm"
               :model="addJanitorForm"
               :rules="addJanitorRule"
               label-width="40%">


        <el-form-item label="公寓名称："
                      prop="apartmentName">
          <span>{{ addJanitorForm.apartmentName }}</span>
        </el-form-item>

        <el-form-item label="管理员手机号"
                      prop="userPhone">
          <el-input style="width: 200px;"
                    v-model="addJanitorForm.userPhone"
                    placeholder="请输入管理员手机号"
                    @keyup.enter.native="addJanitor()"></el-input>
        </el-form-item>

        <el-form-item label="权限" prop="appRoleIdList">
          <el-checkbox-group v-model="appRoleIdList">
            <el-checkbox v-for="item in roleList"
                         :key="item.appRoleId"
                         :label="item.appRoleId"
            >{{ item.appRoleName }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>

      </el-form>


      <span slot="footer"
            class="dialog-footer"
            style="display: flex;justify-content: space-between">
        <el-button @click="cancelAddJanitorDialog()">取 消</el-button>
        <el-button type="primary"
                   @click="addJanitor()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改管理员 -->
    <el-dialog title="管理员信息详情"
               :visible.sync="detailDialog"
               width="50%"
               :before-close="cancelDetailDialog">
      <el-form class="detailForm"
               ref="detailForm"
               :model="detailForm"
               label-width="40%">
        <el-form-item label="公寓名称："
                      prop="apartmentName">
          <span>{{ detailForm.apartmentName }}</span>
        </el-form-item>

        <el-form-item label="房东："
                      prop="landlord">
          <span>{{ detailForm.landlord }}</span>
        </el-form-item>

        <el-form-item label="管理员姓名："
                      prop="userName">
          <span>{{ detailForm.userName }}</span>
        </el-form-item>

        <el-form-item label="管理员手机号："
                      prop="userPhone">
          <span>{{ detailForm.userPhone }}</span>
        </el-form-item>

        <el-form-item label="添加时间："
                      prop="createTime">
          <span>{{ detailForm.createTime }}</span>
        </el-form-item>

        <el-form-item label="角色：" prop="appRoleIdList">
          <el-checkbox-group v-model="appRoleIdList">
            <el-checkbox v-for="item in roleList"
                         :key="item.appRoleId"
                         :label="item.appRoleId"
            >{{ item.appRoleName }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>

      </el-form>
      <span slot="footer"
            class="dialog-footer"
            style="display: flex;justify-content: space-between">
        <el-button @click="cancelDetailDialog()">返 回</el-button>
         <el-button type="primary" @click="editJanitor(detailForm.apartmentUserId)">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import '../assets/css/JanitorManagement.css'

export default {
  data() {
    return {
      apartmentId: '',
      apartmentName: '',
      roleId: '',
      userInfo: {},
      apartmentList: [],
      activeName: '',
      searchForm: {},
      roomTypeList: [
        {
          value: 1,
          label: '普通房间',
        },
        {
          value: 2,
          label: '公共房间',
        },
      ],
      roomStateList: [
        {
          value: 1,
          label: '未入住',
        },
        {
          value: 2,
          label: '入住',
        },
      ],
      roomEquipmentList: [],
      roomTenantList: [],
      dataListLoading: false,
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      detailDialog: false,
      detailForm: {},
      addJanitorDialog: false,
      addJanitorForm: {},
      addJanitorRule: {
        /*        userName: [
                  {required: true, message: '管理员姓名不能为空', trigger: 'blur'},
                ],
                nickName: [
                  {required: false, message: '---', trigger: 'blur'},
                ],*/
        userPhone: [
          {required: true, message: '管理员手机号', trigger: 'blur'},
        ],
        /*        userPassword: [
                  {required: true, message: '管理员密码', trigger: 'blur'},
                ],*/
      },
      roleList: [],
      appRoleIdList: [],
    }
  },

  computed: {},

  created() {
    let self = this

    if (sessionStorage.getItem('userInfo')) {
      self.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    }

    self.getApartmentList()
  },

  mounted() {
  },

  methods: {
    handleClick(tab, event) {
      let self = this

      self.apartmentId = parseInt(tab.name)

      for (var i = 0, len = self.apartmentList.length; i < len; i++) {
        if (self.apartmentList[i].apartmentId == self.apartmentId) {
          self.apartmentName = self.apartmentList[i].apartmentName
          self.roleId = self.apartmentList[i].roleId
        }
      }

      let str = {
        apartmentId: self.apartmentId,
        flag: 1,
        pageNo: 1,
        pageSize: self.pageSize,
      }
      self.getDataList('firstSearch', str)
    },
    // 清空查询条件
    reset() {
      let self = this
      Object.keys(self.searchForm).forEach((key) => (self.searchForm[key] = ''))
    },

    // 获取公寓列表
    getApartmentList() {
      let self = this

      self.$axios
        ._getApartmentList()
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {

            if (datas.data.apartmentList) {
              self.apartmentList = datas.data.apartmentList
            } else {
              self.$message.error('还没有创建公寓，不能加载管理员')
              return
            }

            self.activeName = String(self.apartmentList[0].apartmentId)
            self.apartmentId = self.apartmentList[0].apartmentId
            self.apartmentName = self.apartmentList[0].apartmentName
            self.roleId = self.apartmentList[0].roleId

            let str = {
              apartmentId: self.apartmentId,
              flag: 1,
              pageNo: 1,
              pageSize: self.pageSize,
            }
            self.getDataList('firstSearch', str)
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })
    },

    // 获取管理员列表
    getDataList(type, firstApartment) {
      let self = this

      self.dataListLoading = true

      let str = null

      if (type == 'firstSearch') {
        str = firstApartment
      } else {
        if (type == 'search') {
          self.pageIndex = 1
        }
        str = {
          apartmentId: self.apartmentId,
          janitorName: self.searchForm.janitorName,
          flag: 1,
          pageNo: self.pageIndex,
          pageSize: self.pageSize,
        }
      }


      self.$axios
        ._getJanitorList(str)
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {
            let janitorList = datas.data
            if (janitorList) {
              self.dataList = janitorList
              self.totalPage = janitorList.length
            } else {
              self.dataList = []
              self.totalPage = 0
            }
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })

      self.dataListLoading = false
    },

    // 每页数
    sizeChangeHandle(val) {
      let self = this

      self.pageSize = val
      self.pageIndex = 1
      self.getDataList()
    },

    // 当前页
    currentChangeHandle(val) {
      let self = this

      self.pageIndex = val
      self.getDataList()
    },

    // 打开 新增&修改弹窗
    openModifyDialog: function (row) {
      let self = this

      if (row) {
        let str = {
          apartmentUserId: row.apartmentUserId,
        }

        self.$axios
          ._getRoomInfo(str)
          .then((res) => {
            const datas = res.data

            if (datas.code == 0) {
              self.modifyForm = datas.data
            } else {
              self.$message.closeAll()
              self.$message.error(datas.msg)
            }
          })
          .catch((error) => {
            self.$message.closeAll()
            self.$message.error('系统异常，请联系管理员')
          })
      }

      // self.modifyForm.apartmentAssetStatus = 2
      self.modifyForm.apartmentId = self.apartmentId
      self.modifyDialog = true
    },

    //打开新增管理员的dialog
    openAddJanitorDialog: function () {
      let self = this
      self.getRoleList()
      self.addJanitorDialog = true
      self.addJanitorForm = {
        apartmentName: self.apartmentName,
        apartmentId: self.apartmentId,
      }
    },


    // 获取角色数据列表
    getRoleList() {
      let self = this

      let param = {}

      self.dataListLoading = true


      self.$axios
        ._getAppRoleList({})
        .then((res) => {
          const datas = res.data
          if (datas.code == 0) {
            let _dataList = datas.data
            if (_dataList) {
              self.roleList = _dataList
            } else {
              self.$message.error('还没有创建管理者权限')
              self.dataList = []
            }

          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })

      self.dataListLoading = false

    },
    // 获取管理员在某个公寓的角色数据列表
    getRoleListOfOneApartment(apartmentUserId) {
      let self = this

      let param = {apartmentUserId: apartmentUserId}

      self.dataListLoading = true


      self.$axios
        ._getJanitorAppRoleListByApartmentId(param)
        .then((res) => {
          const datas = res.data
          if (datas.code == 0) {
            let _dataList = datas.data
            if (_dataList) {
              self.roleList = _dataList

              self.appRoleIdList = []
              for (let i = 0; i < self.roleList.length; i++) {
                const obj = self.roleList[i];
                if(obj.checked){
                  self.appRoleIdList.push(obj.appRoleId)
                }
              }

            } else {
              self.$message.error('还没有创建管理者权限')
              self.dataList = []
            }

          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })

      self.dataListLoading = false

    },

    //为房间新增管理员
    addJanitor: function () {
      let self = this

      if (self.appRoleIdList.length == 0) {
        self.$message.error('参数不合格')
        return
      }

      let param = {
        apartmentId: self.addJanitorForm.apartmentId,
        userPhone: self.addJanitorForm.userPhone,
        appRoleIdList: self.appRoleIdList,
      }

      self.$axios
        ._landlordAddJanitor(param)
        .then((res) => {
          const datas = res.data
          if (datas.code == 0) {
            self.cancelAddJanitorDialog()
            self.getDataList('search')
            self.$message.success('添加成功')
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error('系统异常，请联系管理员' + error)
        })
    },

    //编辑管理员
    editJanitor: function (apartmentUserId) {
      let self = this

      if (self.appRoleIdList.length == 0) {
        self.$message.error('参数不合格')
        return
      }

      let param = {
        apartmentUserId: apartmentUserId,
        appRoleIdList: self.appRoleIdList,
      }

      self.$axios
        ._landlordEditJanitor(param)
        .then((res) => {
          const datas = res.data
          if (datas.code == 0) {
            self.cancelDetailDialog()
            self.$message.success('修改成功')
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error('系统异常，请联系管理员' + error)
        })
    },

    //关闭新增管理员
    cancelAddJanitorDialog: function () {
      let self = this

      Object.keys(self.addJanitorForm).forEach((key) => (self.addJanitorForm[key] = ''))
      self.$refs.addJanitorForm.resetFields()
      self.addJanitorDialog = false
      self.roleList = []
    },

    // 打开 房间信息弹窗
    openDetailDialog: function (row) {
      let self = this

      if (row) {
        let str = {
          apartmentUserId: row.apartmentUserId,
        }

        self.$axios
          ._getJanitorDetail(str)
          .then((res) => {
            const datas = res.data

            if (datas.code == 0) {
              self.detailForm = datas.data

              self.getRoleListOfOneApartment(row.apartmentUserId);
            } else {
              self.$message.closeAll()
              self.$message.error(datas.msg)
            }
          })
          .catch((error) => {
            self.$message.closeAll()
            self.$message.error('系统异常，请联系管理员')
          })
      }

      self.detailDialog = true
    },

    // 关闭 房间信息弹窗
    cancelDetailDialog: function () {
      let self = this

      Object.keys(self.detailForm).forEach((key) => (self.detailForm[key] = ''))

      self.appRoleIdList = []
      self.detailDialog = false
    },

    // 删除房间
    handleDelete(row) {
      let self = this

      let param = {apartmentUserId: row.apartmentUserId}

      self
        .$confirm(`是否确认要删除管理员 "${row.userName}" `, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(function () {
          return self.delHome(param)
        })
        .then((data) => {
        })
    },

    delHome(str) {
      let self = this

      self.$axios
        ._landlordRemoveJanitor(str)
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {
            self.$message.success('删除成功')
            self.getDataList('search')
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })

      self.dataListLoading = false
    },
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/JanitorManagement.vue